import React from 'react';
import { toChoiceQuestionAnswerOrEmpty } from '../../stores/QuestionStore';
import { Dropdown } from './Dropdown';
import { DropdownMultiselect } from './DropdownMultiselect';
export const CmdbDropdown = questionProps => {
  var _questionStore$issueF;
  const {
    questionStore
  } = questionProps;
  const shouldRenderMultiple = ((_questionStore$issueF = questionStore.issueFieldData) === null || _questionStore$issueF === void 0 ? void 0 : _questionStore$issueF.multiple) !== false;
  const hasMultipleAnswers = toChoiceQuestionAnswerOrEmpty(questionStore.answer).choices.length > 1;
  if (shouldRenderMultiple || hasMultipleAnswers) {
    return /*#__PURE__*/React.createElement(DropdownMultiselect, questionProps);
  } else {
    return /*#__PURE__*/React.createElement(Dropdown, questionProps);
  }
};